import type { JSX } from 'react';

import RevvlyMark from '../Layout/revvly-mark.svg?react';
import { SignInStatus } from '../WhatsNew/SignInStatus';

import styles from './AuthCardChrome.module.css';

// Staging-only build stamp (short commit SHA), same rule as the sign-in page:
// hidden in production builds, which omit VITE_APP_ENV.
const BUILD_STAMP =
  import.meta.env.VITE_APP_ENV === 'staging' && import.meta.env.VITE_SENTRY_RELEASE
    ? String(import.meta.env.VITE_SENTRY_RELEASE).slice(0, 7)
    : null;

/** The Revvly mark and wordmark, centred at the top of a signed-out card. */
export function AuthBrand(): JSX.Element {
  return (
    <div className={styles.Brand}>
      <RevvlyMark className={styles.Mark} aria-hidden="true" />
      <span className={styles.Wordmark}>Revvly</span>
    </div>
  );
}

/** Platform status line and build stamp, the same footer the sign-in page carries. */
export function AuthFooter(): JSX.Element {
  return (
    <div className={styles.Footer}>
      <SignInStatus />
      {BUILD_STAMP && <p className={styles.Build}>build {BUILD_STAMP}</p>}
    </div>
  );
}
